import { Component, OnInit } from '@angular/core';
import { LanguageService } from './core/services/language.service';
import { TableTooltipService } from './core/services/table-tooltip.service';
import { ServiceWorkerRegister } from './core/service-worker/serviceWorker';

@Component({
  selector: 'megastore-admin-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Edwin';
  
  constructor(
    private languageService: LanguageService,
    private tableTooltipService: TableTooltipService,
    private serviceWorker: ServiceWorkerRegister
  ) {
    this.languageService.initialize();
  }

  ngOnInit() {
    // Initialize table tooltips globally
    this.tableTooltipService.initializeTableTooltips();
    this.serviceWorker.publicApi();
  }
}
